import { render, staticRenderFns } from "./DealsStatus.vue?vue&type=template&id=8519379c"
import script from "./DealsStatus.vue?vue&type=script&lang=js"
export * from "./DealsStatus.vue?vue&type=script&lang=js"
import style0 from "./DealsStatus.vue?vue&type=style&index=0&id=8519379c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports